import { withLocalState } from 'pyradux';

import DocumentationContainer from './Documentation.container';
import reducer from './Documentation.reducer';
import DocumentationSagas from './Documentation.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'documentation',
  sagas: [DocumentationSagas],
};

export default withLocalState(withLocalStateOptions, DocumentationContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/Documentation/index.js